import { SingleTopUpModule } from './single'
import { TopUpModule as ParentTopUpModule } from '../index'
import gql from 'graphql-tag'
import { getProvider } from '@/apollo'
import { splitError } from '@/helper/splitError'
import { SingleTopUpPayPalModule } from './paypal'
import { AutoTopUpModule } from './auto'

const initialState = {
  voucherTopUp: {
    view: 'input',
    amount: 0,
    voucherCode: null
  }
}

const TopUpModule = {
  namespaced: true,
  modules: {
    single: SingleTopUpModule,
    paypal: SingleTopUpPayPalModule,
    auto: AutoTopUpModule
  },
  state: initialState,
  actions: {
    async sendVoucher ({ commit, state, rootGetters }, { voucher, nextStep }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation voucher ($input: String!) {
          topUpVoucher (voucher: $input) {
            amount
          }
        }`,
        variables: {
          input: voucher
        }
      }).then((response) => {
        commit('setVoucherView', nextStep)
        commit('storeVoucherAmount', response.data?.topUpVoucher?.amount)
        commit('Transaction/removeTransactionId', 'voucher', { root: true })
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    },
    async confirmVoucher ({ commit, state, getters }, { nextStep }) {
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation voucher ($input: String!) {
          topUpVoucher (voucher: $input) {
            amount
          }
        }`,
        variables: {
          input: getters.voucherCode
        }
      }).then((response) => {
        commit('addMessage', {
          type: 'success',
          message: 'Die Aufladung wurde erfolgreich ausgeführt.'
        }, { root: true })
        commit('Transaction/removeTransactionId', 'voucher', { root: true })
        commit('changeView', 'topUpVoucherSuccess')
        commit('setVoucherView', nextStep)
      }).catch((error) => {
        commit('changeView', 'input')
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  },
  mutations: {
    returnToInput: ParentTopUpModule.mutations.returnToInput,
    storeTopUpData: (state, topUpData) => {
      state.changeTopUp.topUpData = topUpData
    },
    // Voucher
    storeVoucherAmount: (state, amount) => {
      state.voucherTopUp.amount = amount
    },
    storeVoucherCode: (state, voucherCode) => {
      state.voucherTopUp.voucherCode = voucherCode
    },
    setVoucherView: (state, nextStep) => {
      state.voucherTopUp.view = nextStep
    }
  },
  getters: {
    view: ParentTopUpModule.getters.view,
    amount: ParentTopUpModule.getters.amount,
    voucherCode: state => {
      return state.voucherTopUp?.voucherCode || null
    },
    getView: state => {
      return state.view
    },
    getVoucherView: state => {
      return state.voucherTopUp.view
    },
    getVoucherAmount: state => {
      return state.voucherTopUp.amount
    }
  }
}

export {
  TopUpModule
}
